import { Component, OnInit } from "@angular/core";
import { UserListService } from "../../shared/services";
import { Router, ActivatedRoute } from "@angular/router";
import { CoreService } from "../../shared/services/core/core.service";
import Swal from "sweetalert2";
import { AlertService } from "../../shared/services/alert/alert.service";
import { first } from "rxjs/operators";

@Component({
  selector: "app-users",
  templateUrl: "./users.component.html",
  styleUrls: ["./users.component.scss"]
})
export class UsersComponent implements OnInit {
  userData: any = {
    _id: "",
    email: "",
    phone: "",
    usertype: "",
    role: {  code: "", name: "" },
    disabled: false,
    locked: false
  };
  userId: string;

  roleResult: any = [];
  sender = "users";

  constructor(
    private userListService: UserListService,
    private router: Router,
    private route: ActivatedRoute,
    private coreService: CoreService,
    private alertService: AlertService
  ) {}

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.route.paramMap.subscribe(params => {
        this.userId = params.get("id");

        if (this.userId !== "new") {
          this.userData._id = this.userId;
          this.getUserDetails(this.userId);
        }
      });
    });
  }

  getUserDetails(userId) {
    this.userListService
      .getUserDetails(userId)
      .pipe(first())
      .subscribe(res => {
        this.userData = res;
      });
  }

  isNumber(evt) {
    return this.coreService.isNumeric(evt);
  }

  onSave() {
    if (!this.userData.usertype) {
      this.alertService.err(this.sender, "Please select User Type");
      return false;
    }

    if (!this.userData.role || !this.userData.role.code) {
      this.alertService.err(this.sender, "Please select Role");
      return false;
    }

    if (!this.userData.email) {
      this.alertService.err(this.sender, "Email cannot be left Blank");
      return false;
    }
     
    var data = Object.assign ({}, this.userData);
    data.role = {
      code: this.userData.role.code, 
      name: this.userData.role.name
    };

    this.userListService
      .saveUserList(data)
      .pipe(first())
      .subscribe(res => {
        if (res["status"] == "error"){
          this.alertService.err(this.sender,  res["message"]);
           return;
        }
        this.alertService.show(this.sender, "User saved...");
        this.router.navigate(["manager/users"]);
      });
  }

  onCancel() {
    this.router.navigate(["manager/users"]);
  }

  onDelete() {
    Swal.fire({
      title: "Are you sure?",
      text: "User data will be deleted. This action can't be reversed!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it"
    }).then(result => {
      if (result.value) {
        this.userListService
          .deleteUser(this.userId)
          .pipe(first())
          .subscribe(res => {
            this.onCancel();
          });
      }
    });
  }
}
